import { ReactElement, useState } from 'react'
import { useQueryClient } from 'react-query'
import { Wrapper } from '@farewill/ui'

import Dropdown from 'components/dropdown'
import OwnerAssignmentForm from 'components/owner-assignment-form'
import { AdminUser } from 'lib/models/admin-user'
import { formatAdminUserOptions } from 'utils/helpers'

type OwnerAssignmentDropdownProps = {
  alignment?: 'left' | 'right' | 'center'
  canAssign?: (adminUserId: number | null) => boolean
  header?: string
  initialAdminUserId?: number | null | 'null'
  isSubmitting?: boolean
  loggedInAdminUserId: number
  onAssign: (adminUserId: number | null) => Promise<void> | void
  onToggle?: () => void
  showAssignSelfButton?: boolean
  trigger: ReactElement
  updatedAt?: unknown
}

const OwnerAssignmentDropdown = ({
  alignment,
  canAssign,
  header,
  initialAdminUserId = null,
  isSubmitting = false,
  loggedInAdminUserId,
  onAssign,
  onToggle,
  showAssignSelfButton = true,
  trigger,
  updatedAt,
}: OwnerAssignmentDropdownProps) => {
  const cache = useQueryClient()
  const [isVisible, setIsVisible] = useState(false)

  const adminUsers = cache.getQueryData('adminUsers') as AdminUser[] | undefined
  const adminUserOptions = formatAdminUserOptions(
    adminUsers ?? [],
    loggedInAdminUserId
  )

  const handleAssign = async (adminUserId: number | null) => {
    await onAssign(adminUserId)
    setIsVisible(false)
  }

  const handleToggle = () => {
    setIsVisible((prevVisible) => !prevVisible)
    onToggle?.()
  }

  return (
    <Dropdown
      alignment={alignment}
      isVisible={isVisible}
      toggleCallback={handleToggle}
      updatedAt={updatedAt}
      trigger={trigger}
      content={
        <Wrapper padding="S">
          <OwnerAssignmentForm
            initialAdminUserId={initialAdminUserId}
            adminUserOptions={adminUserOptions}
            isSubmitting={isSubmitting}
            canAssign={canAssign}
            header={header}
            showAssignSelfButton={showAssignSelfButton}
            onAssignSelf={() => handleAssign(loggedInAdminUserId)}
            onAssign={handleAssign}
          />
        </Wrapper>
      }
    />
  )
}

export default OwnerAssignmentDropdown
